import { render, staticRenderFns } from "./atlas-setting.vue?vue&type=template&id=8b9a2d38&scoped=true"
import script from "./atlas-setting.vue?vue&type=script&lang=js"
export * from "./atlas-setting.vue?vue&type=script&lang=js"
import style0 from "./atlas-setting.vue?vue&type=style&index=0&id=8b9a2d38&prod&lang=scss&scoped=true"
import style1 from "./atlas-setting.vue?vue&type=style&index=1&id=8b9a2d38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9a2d38",
  null
  
)

export default component.exports